import React from "react";
import { Card, CardContent } from "@mui/material";
import { useTranslation } from "react-i18next";
import InformationView from "./InformationView";
import { Unit } from "@lib/types/units";

interface UnitCardProps {
  unit: Unit;
}

const UnitCard: React.FC<UnitCardProps> = ({ unit }) => {
  const { t } = useTranslation();

  const unit_info = [
    { label: t("user.units.unitName"), value: unit.name, columnSize: 4 },
    { label: t("user.units.iccid"), value: unit.iccid, columnSize: 4 },
  ];

  return (
    <Card sx={{ width: "100%", margin: 1 }}>
      <CardContent>
        <InformationView data={unit_info} columns={8} />
      </CardContent>
    </Card>
  );
};

export default UnitCard;
